var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 2 24 26",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      stroke: "currentColor",
      overflow: "hidden"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 14-6-6-6 6M12 22V8"
  }))));
};

export default SvgArrow;